import React from 'react';

import styles from './Footer.module.scss';
import Logo from '../../assets/images/6waves_logo.png';

import { CONFIG_FOOTER } from '../../shared/constants';

const footerWrapperMobile = (config) => {
    return (
        <div className={styles.footerWrapper}>
            <img className={styles.logo} src={Logo} alt={''} />
            <div className={`${styles.termsWrapper} ${styles.topRow} ${styles.mobile}`}>
                {CONFIG_FOOTER.hasAdditionalLinks ?
                    <a target={'_blank'} href={'https://www.fun.6waves.jp/q-a'} className={styles.terms}>{config.fAndQ}</a>
                    :
                    null
                }
                {CONFIG_FOOTER.hasAdditionalLinks ?
                    <a target={'_blank'} href={'https://www.fun.6waves.jp/%E8%A6%87%E7%8E%8B%E3%82%AC%E3%82%A4%E3%83%89'} className={styles.terms}>{config.shopGuide}</a>
                    :
                    null
                }
                <a target={'_blank'} href={'https://haou.6waves.jp/rule'} className={styles.terms}>{config.termsAndConditions}</a>
                <a target={'_blank'} href={'https://haou.6waves.jp/privacypolicy-2'} className={styles.terms}>{config.privacyPolicy}</a>
            </div>
            <div className={styles.termsWrapper}>
                <a target={'_blank'} href={'https://haou.6waves.jp/paymentoffunds'} className={styles.terms}>{config.paymentoffunds}</a>
                <a target={'_blank'} href={'https://haou.6waves.jp/fundsettlement'} className={styles.terms}>{config.fundsettlement}</a>
                <a target={'_blank'} href={'http://6waves.jp/support'} className={styles.terms}>{config.support}</a>
            </div>
            <div>&copy; Six Waves Inc. All Rights Reserved.</div>
        </div>
    );
};

const footerWrapperDesktop = (config) => {
    return (
        <div className={styles.footerWrapper}>
            <img className={styles.logo} src={Logo} alt={''}/>
            <div className={`${styles.termsWrapper} ${styles.topRow}`}>
                <p className={styles.linkWrapper}>
                    {CONFIG_FOOTER.hasAdditionalLinks ?
                        <a target={'_blank'} href={'https://www.fun.6waves.jp/q-a'}
                           className={styles.terms}>{config.fAndQ}</a>
                        : null
                    }
                    <a target={'_blank'} href={'https://haou.6waves.jp/paymentoffunds'}
                       className={styles.terms}>{config.paymentoffunds}</a>
                </p>
            </div>
            <div className={styles.termsWrapper}>
                <p className={styles.linkWrapper}>
                    {CONFIG_FOOTER.hasAdditionalLinks ?
                        <a target={'_blank'}
                           href={'https://www.fun.6waves.jp/%E8%A6%87%E7%8E%8B%E3%82%AC%E3%82%A4%E3%83%89'}
                           className={styles.terms}>{config.shopGuide}</a>
                        : null
                    }
                    <a target={'_blank'} href={'https://haou.6waves.jp/fundsettlement'}
                       className={styles.terms}>{config.fundsettlement}</a>
                </p>
            </div>
            <div className={styles.termsWrapper}>
                <p className={styles.linkWrapper}>
                    <a target={'_blank'} href={'https://haou.6waves.jp/rule'}
                       className={styles.terms}>{config.termsAndConditions}</a>
                    <a target={'_blank'} href={'http://6waves.jp/support'} className={styles.terms}>{config.support}</a>
                </p>
            </div>
            <div className={styles.termsWrapper}>
                <p className={styles.linkWrapper}>
                    <a target={'_blank'} href={'https://haou.6waves.jp/privacypolicy-2'}
                       className={styles.terms}>{config.privacyPolicy}</a>
                    <span className={styles.allRights}>&copy; Six Waves Inc. All Rights Reserved.</span>
                </p>
            </div>
        </div>
    );
};

const Footer = ({ config, windowSize, isLoginPage }) => {

    return (
        <div className={`${styles.footerContainer} ${isLoginPage ? styles.login : ''}`}>
            {/* {windowSize.isMobileView ?
                <img className={styles.backgroundMobile} src={BackgroundMobile} alt={''} />
                :
                <img className={styles.background} src={Background} alt={''} />
            } */}
            {windowSize.isMobileView ?
                footerWrapperMobile(config)
                :
                footerWrapperDesktop(config)
            }
        </div>
    );
};

export default Footer;